var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { CpslButton, CpslIcon, CpslQrCode, CpslSpinner, CpslText } from '@usecapsule/react-components';
import { CenteredText, Heading, InnerStepContainer, QRContainer, StepContainer } from '../common.js';
import { useCapsuleStore, useModalStore } from '../../stores/index.js';
import { ModalStep } from '../../utils/steps.js';
import { isMobile } from '@usecapsule/web-sdk';
const FarcasterOAuthStep = () => {
    const setStep = useModalStore(state => state.setStep);
    const setWebAuthURLForCreate = useModalStore(state => state.setWebAuthURLForCreate);
    const setWebAuthURLForLogin = useModalStore(state => state.setWebAuthURLForLogin);
    const setBiometricLocationHints = useModalStore(state => state.setBiometricLocationHints);
    const capsule = useCapsuleStore(state => state.capsule);
    const setFlow = useModalStore(state => state.setFlow);
    const farcasterConnectUri = useModalStore(state => state.farcasterConnectUri);
    const setFarcasterConnectUri = useModalStore(state => state.setFarcasterConnectUri);
    useEffect(() => {
        if (farcasterConnectUri) {
            const pollStatus = () => __awaiter(void 0, void 0, void 0, function* () {
                const { userExists, username } = yield capsule.waitForFarcasterStatus();
                setStep(ModalStep.AWAITING_OAUTH);
                if (userExists) {
                    const webAuthUrlForLogin = yield capsule.initiateUserLogin(username, false, 'farcaster');
                    const biometricLocationHints = yield capsule.getUserBiometricLocationHints();
                    setFlow('login');
                    setWebAuthURLForLogin(webAuthUrlForLogin);
                    setBiometricLocationHints(biometricLocationHints);
                    setStep(ModalStep.BIOMETRIC_LOGIN);
                }
                else {
                    const webAuthURLForCreate = yield capsule.getSetUpBiometricsURL(false, 'farcaster');
                    setFlow('signUp');
                    setWebAuthURLForCreate(webAuthURLForCreate);
                    setStep(ModalStep.BIOMETRIC_CREATION);
                }
            });
            pollStatus();
            return () => {
                setFarcasterConnectUri(undefined);
            };
        }
    }, [farcasterConnectUri]);
    return (_jsx(StepContainer, { "$wide": true, children: isMobile() ? (_jsxs(InnerStepContainer, { children: [_jsx(CpslText, { weight: "medium", color: "secondary", children: `Don’t have Farcaster` }), _jsxs(CpslButton, { as: "a", href: 'https://link.warpcast.com/download-qr', target: "_blank", variant: "secondary", children: [_jsx(CpslIcon, { slot: "start", icon: "linkExternal" }), `Get Farcaster`] })] })) : (_jsxs(_Fragment, { children: [_jsx(Heading, { variant: "headingS", weight: "bold", children: "Sign in using Farcaster" }), _jsxs(InnerStepContainer, { children: [_jsx(CenteredText, { variant: "bodyS", color: "secondary", weight: "medium", children: "Scan the QR code with your phone's camera to proceed." }), _jsx(QRContainer, { children: !farcasterConnectUri ? _jsx(CpslSpinner, { size: 100 }) : _jsx(CpslQrCode, { url: farcasterConnectUri }) })] })] })) }));
};
export default FarcasterOAuthStep;
